import { SelfURIMap, SnowplowAnalyticsProperties } from './appTypings';
import { areenaApiClient } from '../common/utils';

export const areenaApi = {
  url: 'https://areena.api-test.yle.fi',
  uiClient: areenaApiClient,
  uiVersion: '10',
};

export const areenaAppConf = {
  url: 'https://areena-app-configuration.yle.fi/global/test.json',
};

export const locationsApi = 'https://locations.api-test.yle.fi';

export const loginApiUrl = 'https://login.api-test.yle.fi/v1';

export const mediaApiUrl = 'https://media.api-test.yle.fi/v6/';

export const consentApiUrl = 'https://yle-consent-sdk.test.yle.fi/';

export const selfUri: SelfURIMap = {
  elisa: 'https://elisa-areena.test.yle.fi',
  hbbtv: 'https://hbbtv-areena.test.yle.fi',
  philips: 'https://philips-areena.test.yle.fi',
  panasonic: 'https://panasonic-areena.test.yle.fi',
  vestel: 'https://vestel-areena.test.yle.fi',
  hisense: 'https://hisense-areena.test.yle.fi',
  tivo: 'https://tivo-areena.test.yle.fi',
  sony: 'https://sony-areena.test.yle.fi',
  ps4: 'https://playstation4-areena.test.yle.fi',
  ps5: 'https://playstation5-areena.test.yle.fi',
  telia: 'https://telia-areena.test.yle.fi',
  tizen: 'https://samsung-areena.test.yle.fi',
  webos: 'https://lg-areena.test.yle.fi',
};

export const profilesLocalStorageKey = 'profiles_test';

export const profileViewShownStorageKey = 'profile_view_shown_test';

export const searchHistoryStorageKey = 'search_history_test';

export const cloudinaryHostname = 'images-test.cdn.yle.fi';

export const tunnusUrl = 'https://tunnus-test.yle.fi';

export const rememberLastProfileLocalStorageKey = 'remember_last_profile_test';

export const snowplowAnalyticsProperties: SnowplowAnalyticsProperties = {
  collectorUrl: 'haavi-test.yle.fi',
  getAppId: mode => `areena_leanback_${mode}-test`,
  miniCollectorUrl: 'https://fi-yle-dev1.mini.snplow.net',
  trackerNamespace: 'sp1',
};
